import React, { useState } from 'react';
import { X, Calendar, Clock, Trophy, Users, Medal } from 'lucide-react';

const SessionDetailOverlay = ({ session, onClose }) => {
    const [fullscreenImage, setFullscreenImage] = useState(null);
    
    if (!session) return null;

    const formatDuration = (minutes) => {
        if (!minutes) return '-';
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hours > 0) {
            return `${hours}h ${mins}min`;
        }
        return `${mins} min`;
    };

    return (
        <>
            {/* Fullscreen Image Overlay */}
            {fullscreenImage && (
                <div 
                    className="modal-overlay" 
                    onClick={() => setFullscreenImage(null)}
                    style={{ cursor: 'pointer', zIndex: 3000 }}
                >
                    <div 
                        style={{ 
                            position: 'relative',
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button 
                            className="close-btn" 
                            onClick={() => setFullscreenImage(null)}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'rgba(255,255,255,0.9)',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                cursor: 'pointer',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                            }}
                        >
                            <X size={20} />
                        </button>
                        <img 
                            src={fullscreenImage} 
                            alt="Session" 
                            style={{ 
                                maxWidth: '90vw', 
                                maxHeight: '85vh', 
                                borderRadius: '8px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
                            }} 
                        />
                    </div>
                </div>
            )}

            {/* Main Modal */}
            <div className="modal-overlay" onClick={onClose}>
                <div className="modal-content session-detail-modal" onClick={e => e.stopPropagation()}>
                    <button className="close-btn" onClick={onClose}><X /></button>

                    {/* Images Section */}
                    <div className="session-images">
                        {session.gameImage && (
                            <div 
                                className="session-image-wrapper clickable"
                                onClick={() => setFullscreenImage(session.gameImage)}
                                title="Klikkaa avataksesi"
                            >
                                <img 
                                    src={session.gameImage} 
                                    alt={session.gameName} 
                                    className="session-game-image"
                                    onError={(e) => { e.target.onerror = null; e.target.src = '/empty-game.jpg'; }}
                                />
                            </div>
                        )}
                        {session.sessionImage && (
                            <div 
                                className="session-image-wrapper clickable"
                                onClick={() => setFullscreenImage(session.sessionImage)}
                                title="Klikkaa avataksesi"
                            >
                                <img 
                                    src={session.sessionImage} 
                                    alt="Session" 
                                    className="session-selfie-image"
                                />
                            </div>
                        )}
                    </div>

                    {/* Info Section */}
                    <div className="session-info">
                        <h2>{session.gameName}</h2>
                        <div className="session-meta">
                            <span><Calendar size={16} /> {new Date(session.date).toLocaleDateString('fi-FI')}</span>
                            <span><Clock size={16} /> {formatDuration(session.durationMinutes)}</span>
                            <span><Users size={16} /> {session.playerCount} pelaajaa</span>
                        </div>
                    </div>

                    {/* Results Table */}
                    <div className="session-results">
                        <h4><Trophy size={18} /> Tulokset</h4>
                        <table className="results-table">
                            <thead>
                                <tr>
                                    <th>Sija</th>
                                    <th>Pelaaja</th>
                                    <th title="Pelin sisäiset pisteet">VP</th>
                                    <th title="Sarjapisteet sijoituksen perusteella">MP</th>
                                </tr>
                            </thead>
                            <tbody>
                                {session.results && session.results.map((r, i) => (
                                    <tr key={i} className={r.rank === 1 ? 'winner-row' : ''}>
                                        <td>{r.rank}.</td>
                                        <td>{r.playerName}</td>
                                        <td className="raw-score">{r.rawScore ?? '-'}</td>
                                        <td>
                                            <span className="mp-badge">
                                                <Medal size={14} />
                                                <span>{r.leaguePoints ?? 0}</span>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SessionDetailOverlay;
